import React from 'react';
import lottie from 'lottie-web';
import PropTypes from 'prop-types';

import animation from './FlaskAnimation.lottie.json';

import cn from './style.module.scss';

export function FlaskAnimation(props) {
  let element = React.useRef();

  const [anime, setAnime] = React.useState(undefined);

  React.useEffect(() => {
    if (!anime) {
      let a = getLottieInstance(element.current);
      a.play();
      setAnime(a);
    }
  }, []);

  const className = `${cn.lottiePlayerComponent} ${props.className}`;

  return (
    <div className={className}>
      <div ref={element} />
    </div>
  );
}

FlaskAnimation.defaultProps = {
  className: '',
};

FlaskAnimation.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
};

function getLottieInstance(container) {
  return lottie.loadAnimation({
    loop: true,
    autoplay: false,
    container: container,
    animationData: animation,
  });
}
